<button
    class="returnBtn"
    matTooltip="Cambia el método de pago"
    (click)="changeMethod()"
    *ngIf="method">
    <fa-icon icon="arrow-left"></fa-icon> Volver a métodos de pago
</button>
